import { hasOutcome, isExecuted } from 'partner360/features/mdfActivities/helpers/activityOutcome'
import { getPaid, getRequested } from 'partner360/features/mdfActivities/helpers/sumActivities'
import { IMdfActivity } from 'partner360/features/mdfActivities/model/types'

export interface IMdfOverviewMetrics {
  total: number
  linked: number
  unlinked: number
  totalRequested: number
  totalPaid: number
  percentPaid: number
  executedCount: number
  outcomeProvidedCount: number
}

const isLinked = (activity: IMdfActivity): boolean => activity.keyInitiativeId !== null

export const getMdfOverviewMetrics = (
  activities: IMdfActivity[],
  isUsd: boolean
): IMdfOverviewMetrics => {
  const metrics = activities.reduce(
    (acc, activity) => {
      const requested = getRequested(activity, isUsd)

      acc.totalRequested += requested
      acc.totalPaid += getPaid(activity, isUsd)
      if (isLinked(activity)) {
        acc.linked += 1
      } else {
        acc.unlinked += 1
      }

      if (isExecuted(activity)) {
        acc.executedCount += 1
        if (hasOutcome(activity)) {
          acc.outcomeProvidedCount += 1
        }
      }

      return acc
    },
    {
      linked: 0,
      unlinked: 0,
      totalRequested: 0,
      totalPaid: 0,
      executedCount: 0,
      outcomeProvidedCount: 0,
    }
  )

  return {
    total: activities.length,
    linked: metrics.linked,
    unlinked: metrics.unlinked,
    totalRequested: metrics.totalRequested,
    totalPaid: metrics.totalPaid,
    percentPaid:
      metrics.totalRequested > 0
        ? Math.round((metrics.totalPaid / metrics.totalRequested) * 100)
        : 0,
    executedCount: metrics.executedCount,
    outcomeProvidedCount: metrics.outcomeProvidedCount,
  }
}
